import { createContext, useState } from "react";

export const FlightContext = createContext();

export const FlightProvider = ({ children }) => {
    const [flightSearchParams, setFlightSearchParams] = useState({
        nrOfAdult: 1,
        nrOfChild: 0,
        nrOfInfant: 0,
        nrOfInfantWithSeat: 0,
        nrOfYouth: 0,
        nrOfSenior: 0,
        cabinClass: "Y",
        tripType: "rt",
        withBaggage: false,
        refundable: false,
        directFlight: false,
        flexible: false,
        openReturn: false,
        numberOfBounds: 1,
    });
    const [availabilityResults, setAvailabilityResults] = useState(null);
    const [availabilityLoading, setAvailabilityLoading] = useState(false);
    const [availabilityError, setAvailabilityError] = useState(null);
    const [airValidateResults, setAirValidateResults] = useState(null);
    const [passengersInfos, setPassengersInfos] = useState(null);

    return (
        <FlightContext.Provider
            value={{
                flightSearchParams,
                setFlightSearchParams,
                availabilityResults,
                setAvailabilityResults,
                availabilityLoading,
                setAvailabilityLoading,
                availabilityError,
                setAvailabilityError,
                airValidateResults,
                setAirValidateResults,
                passengersInfos,
                setPassengersInfos,
            }}
        >
            {children}
        </FlightContext.Provider>
    );
};
